import { apiService } from '../../../shared/services/apiService';
import {
  CustomerGhlContactService,
  CustomerGhlContactServiceResponse,
} from './customerGhlContactService';

export const scanIqCustomerGhlContactService: CustomerGhlContactService = {
  async getConnectedAccountInfo(customerId, entityId) {
    const resp = await apiService.get<CustomerGhlContactServiceResponse>(
      `/api/scan-iq/customers/${customerId}/ghl/contact`,
      { params: { entityId } },
    );

    return resp.data;
  },

  async refreshConnectionInfo(customerId, entityId) {
    const resp = await apiService.post<CustomerGhlContactServiceResponse>(
      `/api/scan-iq/customers/${customerId}/ghl/contact`,
      undefined,
      { params: { entityId } },
    );

    return resp.data;
  },
};
